module.exports = __webpack_public_path__ + "static/media/andrew.4cc56afe.jpg";